/** Phase-2 placeholder page — shown inside the app shell when a sidebar item
 *  is intentionally NOT yet promoted to a standalone route. The Fortune-500
 *  blueprint expects every link in the sidebar to land somewhere — even
 *  unfinished items — so users learn the IA and know what's coming.
 */
import { useLocation, useNavigate } from "react-router-dom";
import { PageHeader, EmptyState, Button, Pill } from "@/design";

const PAGE_COPY = {
  "/app/rate-card": {
    title: "Rate Card", eyebrow: "STATION",
    body: "Build & price your Sponsor / Standard / Premium tiers, set discounts and minimum buys. This is live inside Dashboard → Setup → Rate Card today — it gets its own page in the next refactor.",
    fallback: "/app/dashboard",
  },
  "/app/schedule": {
    title: "Programme Schedule", eyebrow: "STATION",
    body: "Manage your weekly grid by daypart. Already live inside Dashboard → Setup → Schedule.",
    fallback: "/app/dashboard",
  },
  "/app/reports": {
    title: "WaveScore Reports", eyebrow: "STATION · PHASE 2",
    body: "Weekly branded one-pager PDFs you can send straight to advertisers. Auto-generated every Monday, archived here. Ships in Phase 2.",
    fallback: "/app/dashboard",
  },
  "/app/brand-intel": {
    title: "Brand Intelligence", eyebrow: "AGENCY · PHASE 2",
    body: "Share-of-voice tracking + ad-mention detection across every monitored stream. Ships when ACRCloud + Groq Whisper are wired in Phase 2.",
    fallback: "/app/planning",
  },
};

export default function AppPlaceholder() {
  const loc = useLocation();
  const nav = useNavigate();
  const copy = PAGE_COPY[loc.pathname] || {
    title: "Coming soon", eyebrow: "PHASE 2",
    body: "This section is part of the next batch in our Fortune-500 rebuild.",
    fallback: "/app/dashboard",
  };
  return (
    <div data-testid="app-placeholder">
      <PageHeader tone="dark" eyebrow={copy.eyebrow} title={copy.title}
        actions={<Pill variant="phase2">Phase 2</Pill>} />
      <EmptyState tone="dark"
        title="We're shipping this in a future batch."
        helper={copy.body}
        action={<Button variant="primary" audience="station" onClick={() => nav(copy.fallback)}>Open Dashboard</Button>} />
    </div>
  );
}
